/**
 * @file Displays a grid of images.
 */
import React from 'react';
import { Image } from '../models/types';

interface ImageGridProps {
  images: Image[];
}

const ImageGrid: React.FC<ImageGridProps> = ({ images }) => {
    if (!images || images.length === 0) {
        return React.createElement('p', null, 'No hay imágenes disponibles para este pedido.');
    }

    return React.createElement('div', { className: 'image-grid' },
        images.map((image, index) => {
            const price = parseFloat(image.price) || 0;
            const quantity = Number.parseInt(String(image.quantity), 10);
            const normalizedQuantity = Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
            const subtotal = price * normalizedQuantity;

            return React.createElement('div', { key: index, className: 'image-item' },
                React.createElement('img', {
                    src: image.url,
                    alt: image.description || `Verificación de pedido ${index + 1}`
                }),
                React.createElement('div', { className: 'image-price' },
                    normalizedQuantity > 1
                        ? `${normalizedQuantity} × $${price.toFixed(2)} = $${subtotal.toFixed(2)}`
                        : `$${price.toFixed(2)}`
                )
            );
        })
    );
};

export default ImageGrid;
